export default __webpack_public_path__ + "static/2-0bed8891ca5008e3a1819cbafa946b79.jpg";